module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/6@2x_cd60d232c12558882d50447fe2c66c0e.png";